import {logger} from './logger';

const BASE_URL = import.meta.env.VITE_NCB_BASE_URL || 'https://openapi.nocodebackend.com';
const INSTANCE_ID = import.meta.env.VITE_NCB_INSTANCE_ID || '53830_users';
const API_KEY = import.meta.env.VITE_NCB_API_KEY;

const ncbClient = {
  async request(method, path, body = null, queryParams = {}) {
    const url = new URL(`${BASE_URL}${path}`);
    url.searchParams.set('Instance', INSTANCE_ID);
    
    // Add extra query parameters
    Object.entries(queryParams).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });

    const headers = {
      'Content-Type': 'application/json'
    };

    if (API_KEY) {
      headers['Authorization'] = `Bearer ${API_KEY}`;
    }

    const requestData = {
      headers: { ...headers },
      body: body ? JSON.stringify(body) : null
    };

    const logEntry = logger.logRequest('ncb', method, url.toString(), requestData);
    const startTime = Date.now();

    try {
      const fetchOptions = {
        method,
        headers
      };

      if ((method === 'POST' || method === 'PUT') && body) {
        fetchOptions.body = JSON.stringify(body);
      }

      const response = await fetch(url.toString(), fetchOptions);
      const duration = Date.now() - startTime;
      
      const contentType = response.headers.get('content-type') || '';
      let responseData;
      
      if (contentType.includes('application/json')) {
        responseData = await response.json();
      } else {
        responseData = await response.text();
      }

      logger.logResponse(logEntry.id, response.status, responseData, duration, {
        'content-type': contentType,
        status: response.status,
        statusText: response.statusText
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      return responseData;
    } catch (error) {
      const duration = Date.now() - startTime;
      logger.logError(logEntry.id, error, 0);
      throw error;
    }
  },

  // Convenience methods
  createUser: (userData) => ncbClient.request('POST', '/create/users', userData),
  getUsers: (queryParams = {}) => ncbClient.request('GET', '/read/users', null, queryParams),
  getUserById: (id) => ncbClient.request('GET', `/read/users/${id}`),
  searchUsers: (criteria) => ncbClient.request('POST', '/search/users', criteria),
  updateUser: (id, userData) => ncbClient.request('PUT', `/update/users/${id}`, userData),
  deleteUser: (id) => ncbClient.request('DELETE', `/delete/users/${id}`),
  
  getSampleRequests: () => ({
    createUser: {
      username: 'testuser',
      password: 'testpass123'
    },
    searchUsers: {
      username: 'testuser'
    },
    updateUser: {
      username: 'updateduser',
      password: 'newpass123'
    }
  })
};

export { ncbClient };